import { AppStateService } from 'src/app/core/services/app-state.service';

import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  contentChildren,
  inject,
  viewChild,
} from '@angular/core';
import { fromEvent } from 'rxjs';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { RoutingStateService } from 'src/app/core/services/routing-state.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { DynamicTabsDirective } from './dynamic-tabs.directive';
import { TabDynamicComponent } from './tab-dynamic/tab-dynamic.component';

@Component({
  selector: 'app-tabs-dynamic',
  templateUrl: './tabs-dynamic.component.html',
  styleUrls: ['./tabs-dynamic.component.scss'],
  standalone: false,
})
export class TabsDynamicComponent implements OnInit {
  //#region properties
  appState = inject(AppStateService);
  routingState = inject(RoutingStateService);
  // routeStateService = inject(RouteStateService);
  route = inject(ActivatedRoute);
  location = inject(Location);
  dynamicTabs: TabDynamicComponent[] = [];

  closedTabName = '';

  // @ContentChildren(TabDynamicComponent) tabs: QueryList<TabDynamicComponent>;
  // @ViewChild(DynamicTabsDirective) dynamicTabPlaceholder: DynamicTabsDirective;

  dynamicTabPlaceholder = viewChild.required(DynamicTabsDirective);
  tabs = contentChildren(TabDynamicComponent);

  //#endregion

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private dynamicTabService: DynamicTabService
  ) {}

  ngOnInit(): void {}

  ngAfterContentInit() {
    const activeTabs = this.dynamicTabs.filter((tab) => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs()[0]);
    }
  }

  ngAfterViewInit() {
    fixTabWidth();

    function fixTabWidth() {
      let dashboard = document.getElementById('content_block');
      document.getElementById('tabs').style.width =
        dashboard.offsetWidth + 5 + 'px';
    }

    fromEvent(window, 'resize').subscribe((res) => {
      fixTabWidth();
    });

    fromEvent(document.getElementById('kt_aside_toggle'), 'click').subscribe(
      (res) => {
        this.onRotateAsideToggle();

        const timeOut = setTimeout(() => {
          fixTabWidth();
          clearTimeout(timeOut);
        }, 300);
      }
    );

    // this.openDefaultTabs();
  }

  // openDefaultTabs() {
  //   this.defaultTabs.forEach((tab) => {
  //     this.openTab(tab.title, tab.name, tab.component, null, false);
  //   })
  // }

  onRotateAsideToggle() {
    const asideToggle = document.getElementById('kt_aside_toggle');
    const icon = asideToggle.querySelector('.svg-icon');
    const dir = document.getElementsByTagName('html')[0].getAttribute('dir');

    if (dir == 'rtl') {
      icon.classList.toggle('aside_toggle-rotate-rtl');
      icon.classList.remove('aside_toggle-rotate-ltr');
    }

    if (dir == 'ltr') {
      icon.classList.toggle('aside_toggle-rotate-ltr');
      icon.classList.remove('aside_toggle-rotate-rtl');
    }
  }

  openTab(
    title: string,
    name: string,
    component,
    data,
    isCloseable = false,
    isMainMenu: boolean = true
  ) {
    // get a component factory for our TabComponent
    this.dynamicTabService.closeTab.set(false);
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory(
        TabDynamicComponent
      );

    // fetch the view container reference from our anchor directive
    const viewContainerRef = this.dynamicTabPlaceholder().viewContainer;

    // alternatively...
    // let viewContainerRef = this.dynamicTabPlaceholder;

    // create a component instance
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // set the according properties on our component instance
    const instance: TabDynamicComponent =
      componentRef.instance as TabDynamicComponent;

    instance.title = title;
    instance.name = name;
    instance.component = component;
    instance.dataContext = data;
    instance.isCloseable = isCloseable;
    instance.isMainMenu = isMainMenu;
    // remember the dynamic component for rendering the
    // tab navigation headers
    this.dynamicTabs.push(componentRef.instance as TabDynamicComponent);

    // set it active
    this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    this.getActiveTab(name);
  }

  refreshTab(tabName: string) {
    this.routingState.removeTab(tabName);
    let tab;
    this.dynamicTabs.forEach((dynamicItem) => {
      if (dynamicItem.name == tabName) tab = dynamicItem;
    });
    tab.loadComponent();
    this.selectTab(tab, true);
  }

  refreshStaticTab(tabName) {
    this.routingState.setResetTabName(tabName);

    this.appState.refreshedTabName.set('');
    this.appState.refreshedTabName.set(tabName);
  }

  /** جهت اکتیو کردن تب */
  selectTab(tab: TabDynamicComponent, isRefresh?: boolean) {
    const dashboardTitle = 'layout.asideMenu.Dashboard';
    if (tab.title === dashboardTitle) this.dynamicTabService.setActiveTab('');
    [...this.tabs(), ...this.dynamicTabs].forEach((t) => (t.active = false));
    tab.active = true;
    this.setRoute(tab, isRefresh);
  }

  /** اگر روت در استیت وجود نداشت ایجاد کن اگر وجود داشت از حافظه استیتش رو بخون به همراه کوئری هاش */
  setRoute(tab: TabDynamicComponent, isRefresh?: boolean) {
    const pathname = window.location.pathname.replace('/', '');

    let currentTab = this.routingState.tabs.find((t) => t.name === pathname);
    if (currentTab) currentTab.query = window.location.search;
    else if (this.closedTabName !== pathname && this.closedTabName != 'all') {
      let query: string;
      if (isRefresh)
        query =
          this.routingState.isChildQuery(window.location.search) &&
          !window.location.search.includes(QueryStringTypesEnum.Campaign_key) &&
          this.routingState.isNotNewTabChilds()
            ? ''
            : window.location.search;
      else query = window.location.search;

      this.routingState.tabs.push({ name: pathname, query });
    }

    this.closedTabName = '';
    let selectedTab = this.routingState.tabs.find((t) => t.name === tab.name);

    // این مورد هم لایه سوم هست و هم توی تب جدید باز میشه و استثنا هست
    if (tab.name != 'sendSmartDetailsByDelivery')
      this.location.go(tab.name + (selectedTab ? selectedTab.query : ''));
  }

  closeTab(tab: TabDynamicComponent) {
    this.dynamicTabService.closeTab.set(true);
    this.routingState.tabs = [
      ...this.routingState.tabs.filter((a) => a.name != tab.name),
    ];
    this.closedTabName = tab.name;

    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        // remove the tab from behavior Subject
        this.removeTabFromSubject(this.dynamicTabs[i].name);
        // remove the tab from our array
        this.dynamicTabs.splice(i, 1);

        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder().viewContainer;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        // set tab index to 1st one
        if (this.dynamicTabs.length == 0 || (i == 0 && tab?.active)) {
          this.selectTab(this.tabs()[0]);
        } else if (tab?.active) {
          this.selectTab(this.dynamicTabs[i - 1]);
        }
        break;
      }
    }
  }

  manualCloseTab(tabName: string) {
    const tab = this.dynamicTabs.find((tab) => {
      return tab.name == tabName;
    });
    
    this.routingState.tabs = [
      ...this.routingState.tabs.filter((a) => a.name != tab.name),
    ];

    if (!tab) return;

    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        // remove the tab from behavior Subject
        this.removeTabFromSubject(this.dynamicTabs[i].name);
        // remove the tab from our array
        this.dynamicTabs.splice(i, 1);

        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder().viewContainer;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        // set tab index to 1st one
        if (this.dynamicTabs.length == 0 || (i == 0 && tab?.active)) {
          this.selectTab(this.tabs()[0]);
        } else if (tab?.active) {
          this.selectTab(this.dynamicTabs[i - 1]);
        }
        break;
      }
    }
  }

  closeActiveTab() {
    const activeTabs = this.dynamicTabs.filter((tab) => tab.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }

  removeTabFromSubject(tabName: string) {
    let tablist = [];
    tablist = this.dynamicTabService.currentTabs();
    for (let i = 0; i < tablist.length; i++) {
      if (tablist[i] === tabName) {
        tablist.splice(i, 1);
      }
    }
    this.dynamicTabService.setCurrentTabs(tablist);
  }

  getActiveTab(tabName) {
    if (tabName) this.dynamicTabService.setActiveTab(tabName);
  }

  closeAllTab() {
    this.routingState.tabs = [...[{ name: 'dashboard', query: '' }]];
    this.closedTabName = 'all';
    let viewContainerRef = this.dynamicTabPlaceholder().viewContainer;

    this.dynamicTabs.forEach((tab, index) => {
      if (tab.name != 'dashboard') {
        this.removeTabFromSubject(tab.name);
        viewContainerRef.remove(0);
      }
    });

    this.dynamicTabs = [];
    this.dynamicTabService.setActiveTab('');
    this.selectTab(this.tabs().find((a) => a.name == 'dashboard'));
  }

  isShowRefreshBtn(tabName) {
    return !this.routingState.isHideRefreshBtnList(tabName);
  }
  
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dynamicTabs, event.previousIndex, event.currentIndex);
  }
}
